export var FlowBlockState;
(function (FlowBlockState) {
    FlowBlockState["Pending"] = "Pending";
    FlowBlockState["Queued"] = "Queued";
    FlowBlockState["Running"] = "Running";
    FlowBlockState["PendingRetry"] = "PendingRetry";
    FlowBlockState["Waiting"] = "Waiting";
    FlowBlockState["Completed"] = "Completed";
    FlowBlockState["Invalidated"] = "Invalidated";
    FlowBlockState["Failed"] = "Failed";
})(FlowBlockState || (FlowBlockState = {}));
/** States a block never leaves. */
export const TERMINAL_FLOW_BLOCK_STATES = [
    FlowBlockState.Completed,
    FlowBlockState.Invalidated,
    FlowBlockState.Failed,
];
export const FAILURE_FLOW_BLOCK_STATES = [FlowBlockState.Failed];
//# sourceMappingURL=blockState.js.map